import {Component, Input} from '@angular/core';
import {OrganizationConstant} from '@models/adminstration/organization/constants/organization-constant';
import {TranslateService} from '@ngx-translate/core';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {NotificationService} from '@services/notification/notification.service';
import {ConstantsService} from '@services/administration/organization/configuration/constants/constants.service';
import {ConfirmationDialogComponent} from '@shared/confirmation-dialog/confirmation-dialog.component';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {PortalGeneralSetting} from '@models/adminstration/organization/constants/portal-general-setting';
import {ConstantModalComponent} from '@components/administration/organization/configuration/constants/constant-modal/constant-modal.component';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-admin-organization-constant-actions',
    templateUrl: './constant-actions.component.html',
    styleUrls: ['./constant-actions.component.scss'],
    standalone: false
})
export class ConstantActionsComponent  {
  private COMPONENT_NAME: string = 'ConstantActionsComponent';
  @Input()
  organizationId: number = -1;

  @Input()
  constants: OrganizationConstant[] | undefined;

  @Input()
  constant: OrganizationConstant = new OrganizationConstant();

  @Input()
  portalSettings: PortalGeneralSetting[] = new Array<PortalGeneralSetting>();

  @Input()
  isAdminRole: boolean = false;

  @Input()
  isSuperAdminRole: boolean = false;


  constructor(private modalService: ModalService,
              private translate: TranslateService,
              private loadingIndicator: LoadingIndicatorService,
              private notification: NotificationService,
              private constantsService: ConstantsService) {
  }

  onRemoveConstant(constant: OrganizationConstant) {
    const removeMessageTitle = this.translate.instant('Delete organization constant');
    const removeMessageBody = this.translate.instant('Do you really want to permanently delete the organization constant %s ?')
    .replace('%s', constant.portalSetting.name.toBold());
    const removeMessageOK = this.translate.instant('Delete constant');
    const removeMessageCancel = this.translate.instant('Cancel');

    const modalRef = this.modalService.open(ConfirmationDialogComponent);
    modalRef.componentInstance.title = removeMessageTitle;
    modalRef.componentInstance.body = removeMessageBody;
    modalRef.componentInstance.cancelButtonText = removeMessageCancel;
    modalRef.componentInstance.okButtonText = removeMessageOK;

    modalRef.result.then(() => {}, (reason) => {
      if (reason === ModalDialogDismissOption.CANCEL || reason === ModalDialogDismissOption.CLOSE) {
        return;
      }
      this.loadingIndicator.show(this.translate.instant('Deleting organization constant'));
      this.constantsService.deleteConstant(this.organizationId, constant.tenantConstant.id).subscribe({
        next: (_success) => {
          const index = this.constants?.indexOf(constant);
          if (index != undefined && index > -1) {
            this.constants?.splice(index, 1);
          }
          const message = this.translate.instant('The constant: "#" was deleted.').replace('#', constant.portalSetting.name);
          this.notification.success(message, this.COMPONENT_NAME, false);
          this.loadingIndicator.hide();
        },
        error: (error) => {
          const message = this.translate.instant('There was an error deleting constant') + ': "' + constant.portalSetting.name + '". ';
          this.notification.error(message, error, this.COMPONENT_NAME, true);
          this.loadingIndicator.hide();
        }
      });
    });
  }

  onEditConstant(constant: OrganizationConstant) {
    const constantBackup = this.constantsService.copyConstantProperties(constant, null);
    const modalRef = this.modalService.open(ConstantModalComponent, {size: 'lg'});
    modalRef.componentInstance.portalSettings = this.portalSettings;
    modalRef.componentInstance.constant = constant;
    modalRef.componentInstance.constants = this.constants;
    modalRef.componentInstance.organizationId = this.organizationId;


    modalRef.result.then((result) => {
      this.loadingIndicator.show(this.translate.instant('Saving organization constant'));
      this.constantsService.saveConstant(this.organizationId, result).subscribe({
        next: (success) => {
          const message = this.translate.instant('Organization constant saved.');
          this.constant = this.constantsService.copyConstantProperties(success, this.constant);
          this.notification.success(message, this.COMPONENT_NAME, false);
          this.loadingIndicator.hide();
        },
        error: (error) => {
          this.notification.error(this.translate.instant('Error saving organization constant'),
            error, this.COMPONENT_NAME, true);
          this.constant = this.constantsService.copyConstantProperties(constantBackup, this.constant);
          this.loadingIndicator.hide();
        }
      });

    }, (_reason) => {
      this.constant = this.constantsService.copyConstantProperties(constantBackup, this.constant);
    });
  }
}
